// Eminence brand mark — uses the official logo artwork. Charcoal version on
// light backgrounds (solid navbar), cream version on dark (hero navbar, footer).
export default function Logo({ dark = false, size = "md", className = "" }) {
  const base = process.env.PUBLIC_URL || "";
  const src = dark
    ? `${base}/brand/eminence-charcoal.png`
    : `${base}/brand/eminence-cream.png`;
  const height = size === "sm" ? 54 : 72;

  return (
    <img
      src={src}
      alt="Eminence Windows & Doors"
      data-testid="site-logo"
      className={className}
      style={{ height, width: "auto", display: "block" }}
    />
  );
}
